module.exports = __webpack_public_path__ + "static/media/lupa.c3c8b32f.svg";